import { IntegrationsSubPanel } from '@repo/utils/types';
import CardDav from './CardDav';
import Zapier from './Zapier';
import Make from './Make';

export const integrationsSubSectionPanels: Record<IntegrationsSubPanel, () => JSX.Element> = {
  'card-dav': CardDav,
  'zapier': Zapier,
  'make': Make,
};
